import React, { useContext, useState } from 'react';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { KeyboardArrowDown } from '@mui/icons-material';
import styles from './common.module.scss';
import NestedModifiers from '../NestedModifiers';
import { IItemsModifier } from './common';
import { getFormattedPrice } from '../../helper/common';
import MenuItemsPageContext, { IMenuItemContext } from '../../../Contexts/MenuItemsPageContext/MenuItemsPageContext';
import { Checkbox, FormControlLabel } from '@mui/material';

interface ICheckBoxFieldProps {
	modifier: IItemsModifier;
	selectedModifierSets: string[];
	maxModifiersPerSet: number;
	parentKey: string;
	handleModifiers(updateSelectedModifierSets: string[], selectedKey?: string, controlSelection?: string): void;
	isChildDisabled: boolean;
	modifierSetIndex: string;
}

const CheckBoxField: React.FC<ICheckBoxFieldProps> = ({
	modifier,
	selectedModifierSets,
	handleModifiers,
	parentKey,
	maxModifiersPerSet,
	isChildDisabled,
	modifierSetIndex,
}: ICheckBoxFieldProps) => {
	const { merchantData } = useContext(MenuItemsPageContext) as IMenuItemContext;
	const [expand, setExpand] = useState(false);
	const modifierRef = modifier?.modifierRef;
	const modifierName = modifier?.modifierDetails?.name;
	const modifierPrice = modifier?.modifierDetails?.price;
	const modifierSets = modifier?.modifierSets || [];
	const isModifierChecked = selectedModifierSets.filter((modifierData) => modifierData === modifier.key).length > 0;
	// use of 37: 37 + parentKey = modifier.length
	const isDisabled =
		!isModifierChecked &&
		selectedModifierSets.filter(
			(modifierData) => parentKey.length + 37 === modifierData.length && modifierData.includes(parentKey)
		).length === maxModifiersPerSet;

	const handleExpandCollapse = () => {
		setExpand(!expand);
	};

	const handleModifier = (isChecked: boolean) => {
		setExpand(isChecked);
		if (isChecked) {
			const updateModifierSets: string[] = selectedModifierSets?.length ? selectedModifierSets : [];
			handleModifiers([...updateModifierSets, modifier.key], modifier.key, 'checked');
		} else {
			handleModifiers(
				selectedModifierSets.filter((modifierSet) => modifierSet !== modifier.key),
				modifier.key,
				'unchecked'
			);
		}
	};
	return (
		<div
			id={modifier.key}
			key={`${modifierRef}-${modifier.key}`}
			className={
				isDisabled || isChildDisabled
					? `${styles.modifierBlock} ${styles.modifierDisabled}`
					: styles.modifierBlock
			}
		>
			<div className={`${styles.selectionBlock} ${isModifierChecked && styles.selectedChecked} ${styles.checkboxDiv}`}>
				<FormControlLabel
					control={
						<Checkbox
							checked={isModifierChecked}
							onChange={(e) => handleModifier(e.target.checked)}
							disabled={isDisabled || isChildDisabled}
							value={modifierRef}
							name={`${modifierRef}-${parentKey}`}
							id={`${modifierRef}-${parentKey}`}
							className={styles.checkboxButton}
						/>
					}
					label={''}
				/>

				{merchantData && (
					<>
						<label
							className={styles.labelBlock}
							htmlFor={`${modifierRef}-${parentKey}`}
						>
							<span className={styles.labelName}>
								{modifierName}{' '}
							</span>
							<div className={styles.labelBlockLeft}>
								<span className={styles.modifierPrice}>	
									{modifierPrice && modifierPrice !== 0
										? `+ ${getFormattedPrice(modifierPrice, merchantData?.currency)}`
										: null
									}
								</span>
							</div>
						</label>
						{modifierSets?.length > 0 && (
							<button className={styles.cartIconStyle} onClick={handleExpandCollapse}>
								{' '}
								{expand ? <KeyboardArrowDown /> : <KeyboardArrowRightIcon />}{' '}
							</button>
						)}
					</>
				)}
			</div>
			<div className={expand ? styles.modifierBody : styles.hideModifierBody}>
				{modifierSets?.length > 0 && (
					<NestedModifiers
						modifierSets={modifierSets}
						selectedModifierSets={selectedModifierSets}
						onHandleModifier={handleModifiers}
						isChildDisabled={isDisabled}
						modifierLastIndex={modifierSetIndex}
					/>
				)}
			</div>{' '}
		</div>
	);
};

export default CheckBoxField;
